"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOrdinal = void 0;
const createOrdinal = (question, value, scope, ordinals) => {
    ordinals.push(Object.assign({ scope: { create: scope }, value }, (question.label
        ? { Question: { connect: { label: question.label } } }
        : { QuestionGrouping: { connect: { uniqueKey: question.uniqueKey } } })));
};
exports.createOrdinal = createOrdinal;
